<div [class.row]="isInline()">
  <div [class.text-end]="isInline()" [class.col-sm-2]="isInline()">
    <label [class.col-form-label]="isInline()" class="form-label fw-bold">{{ name }}</label>
  </div>
  <div [class.col-sm-10]="isInline()">
    <shared-ui-inputs-text-field
      [parentFormGroup]="parentFormGroup"
      [name]="name"
      [formName]="formName"
      [placeholder]="placeholder"
      [tabIndex]="tabIndex"
      [numRows]="numRows"
      [isFocused]="isFocused"
    >
    </shared-ui-inputs-text-field>
  </div>
</div>
